// extracted by mini-css-extract-plugin
export default {"desert":"Innovator_desert__FWURE"};